import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e8432e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_2 = {
  key: 1,
  class: "training-price-summary"
}
const _hoisted_3 = { class: "price-label" }
const _hoisted_4 = { class: "line-discount text-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-1" }, null, -1))
const _hoisted_6 = { class: "text-muted lead text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isModularTraining)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_ctx.trainingTitle), 1))
      : _createCommentVNode("", true),
    (_ctx.vm?.courses?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.courses, (course, i) => {
            return (_openBlock(), _createBlock(_component_Panel, {
              collapsed: _ctx.panelCollapse[i],
              "onUpdate:collapsed": ($event: any) => ((_ctx.panelCollapse[i]) = $event),
              key: i,
              class: "mb-1",
              header: _ctx.courseById(course.id)?.name
            }, {
              icons: _withCtx(() => [
                _createVNode(_component_Button, {
                  class: "p-button-text p-panel-header-icon",
                  icon: _ctx.panelCollapse[i] ? 'pi pi-chevron-left' : 'pi pi-chevron-down',
                  onClick: ($event: any) => (_ctx.panelCollapse[i] = !_ctx.panelCollapse[i])
                }, null, 8, ["icon", "onClick"])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedLines(course), (line) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: line,
                    class: "text-muted"
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.lineText(line)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(line.totalPrice)), 1)
                  ]))
                }), 128)),
                _createElementVNode("p", _hoisted_4, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t("common.priceSummary.subtotal")), 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(course.totalPrice)), 1)
                ]),
                (
					!_ctx.vm.isValid &&
					_ctx.vm.errorCode === _ctx.TrainingCalculationErrorCodeEnum.durationError &&
					_ctx.minimumRequiredDurationToBeValid(course)
				)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      closable: false,
                      severity: "warn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_i18n_t, { keypath: "training.message.minimumRequiredDurationToBeValid" }, {
                          default: _withCtx(() => [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("common.hour", [_ctx.minimumRequiredDurationToBeValid(course)])), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["collapsed", "onUpdate:collapsed", "header"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createVNode(_component_PriceSummary, { vm: _ctx.totalPriceSummary }, null, 8, ["vm"]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("common.productSummary.allPricesExclVat")), 1)
  ], 64))
}